module.exports = __webpack_public_path__ + "media/images/mobile/solutions/34-b293585aa654e00035ee6487476cfd52.png";